/* eslint-disable eslint-plugin-next/no-html-link-for-pages */

import { font, themedColor } from '@lemonade-hq/cdk';
import { useI18nContext } from '@lemonade-hq/nuiza';
import styled from 'styled-components';

const SubsectionContainer = styled.dl<{ capitalize?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 120rem;
  padding: 20px;
  width: 100%;
  margin: 0 auto;
  ${font('main', { fontSize: '1.6rem', fontWeight: 400, lineHeight: '2rem' })};

  & a {
    color: ${themedColor('boulder')};
  }

  & dt,
  & dt a {
    text-transform: uppercase;
    color: ${themedColor('night')};
    ${font('main', {
      fontSize: '1.4rem',
      fontWeight: 700,
      lineHeight: '2.4rem',
    })};
  }

  & dd {
    text-transform: ${({ capitalize }) => (capitalize ? 'capitalize' : 'none')};
  }
`;

interface Item {
  title: string;
  href: string;
}

export interface SubsectionProps {
  title: string;
  href: string;
  items: Item[];
}

export const Subsection: React.FC<SubsectionProps> = ({ title, items, href }) => {
  const Text = href ? 'a' : 'span';
  const { lang } = useI18nContext();
  return (
    <SubsectionContainer capitalize={lang === 'en'}>
      <dt>
        <Text href={href || undefined}>{title}</Text>
      </dt>
      {items.map(item => (
        <dd key={item.href}>
          <a href={item.href}>{item.title}</a>
        </dd>
      ))}
    </SubsectionContainer>
  );
};
